import { defineStore } from 'pinia'

export const useCurrencyStore = defineStore('currency', () => {
  const {
    defaultCurrency = 'EUR'
  } = useRuntimeConfig()

  const currency = useCookie<string>('currency', { default: () => defaultCurrency })

  return {
    currency
  }
})
